export interface ErrorStatus {
  minOrderValueErrorMsg: string
  minOrderValueError: boolean
  prepaidShareValueErrorMsg: string
  prepaidShareValueError: boolean
  [key: string]: string | boolean
}

export enum focusOnType {
  minOrderValue = 'minOrderValue',
  flat = 'flat',
  percentage = 'percentage'
}

export enum PrepaidShareType {
  Flat = 'FLAT',
  Percentage = 'PERCENTAGE'
}

export type SplitCODPayload = {
  enable: boolean
  slabs?: {
    min_payment_value: number
    max_payment_value: number | null
    prepaid_share: number
    prepaid_share_type: PrepaidShareType
    exclude_cod_charges: boolean
  }[]
}

export type SplitCodSlabType = {
  minOrderValue: number
  maxOrderValue: number | null
  prepaidShare: number
  prepaidShareType: PrepaidShareType
  isCODChargesExcluded: boolean
}

export type SplitCodConfigType = {
  isEnabled: boolean
  slabs: SplitCodSlabType[]
}
export type DiscountConfigType = {
  isDiscountEdit: boolean
  discountId: string
  discounstDescription: string
}

type AddressLineConfig = {
  isEnabled: boolean
  isMandatory: boolean
  minCharacterLimit: number
}

type EmailConfig = {
  isEnabled: boolean
  isMandatory: boolean
}

export type AddressConfigType = {
  addressLine1: AddressLineConfig
  addressLine2: AddressLineConfig
  email: EmailConfig
  gibberishCheckEnabled: boolean
  gibberishThreshold: number
  allowUnicode: boolean
}

export interface RTOStateType {
  splitCodConfig: SplitCodConfigType
  isC2pEnabled: boolean
  discountConfig: DiscountConfigType
  codVerification: string
  mandatoryOtpEnabled: boolean
  addressConfig: AddressConfigType
}
export interface RTOSuiteContextType {
  state: RTOStateType
  actions: {
    setSplitCodConfig: (splitCodConfig: SplitCodConfigType) => void
    setInitialSplitCodConfig: (splitCodConfig: SplitCodConfigType) => void
    setC2pConfig: (isEnabled: boolean) => void
    setDiscountConfig: (discountConfig: DiscountConfigType) => void
    setVerifyCod: (codConfig: string) => void
    setMandatoryOTP: (isEnabled: boolean) => void
    setDiscardChanges: (componentsArray?: Array<string>) => void
    setSaveChanges: (componentsArray?: Array<string>) => void
    setAddressConfig: (addressConfig: AddressConfigType) => void
  }
  initialRtoState: RTOStateType
}
export type SplitCodType = Required<SplitCODPayload>
